export default function Logo({ size = 'md' }) {
  const sizes = { sm: 'text-lg', md: 'text-2xl', lg: 'text-5xl' }

  return (
    <div className="flex items-center gap-2">
      <div
        style={{
          background: 'linear-gradient(135deg, #34D399 0%, #14B8A6 100%)',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
        }}
      >
        <span
          className={`font-black tracking-tight ${sizes[size]}`}
          style={{ fontFamily: "'Orbitron', sans-serif" }}
        >
          ChemCraft
        </span>
      </div>
    </div>
  )
}
